// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"725a500c","453":"af25544d"}[chunkId] + ".chunk.js";
};